// extracted by mini-css-extract-plugin
export default {"language__btns":"lang-btn_language__btns__drbcs","language__btn":"lang-btn_language__btn__DtCqZ"};